import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=d974b35a&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d974b35a')) {
      api.createRecord('d974b35a', component.options)
    } else {
      api.reload('d974b35a', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=d974b35a&", function () {
      api.rerender('d974b35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/app-manage/settings.vue"
export default component.exports